// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // baseUrl: 'https://192.168.4.59:90/'
  // baseUrl: ''
  baseUrl: 'https://panelapp.phronesis-partners.com/'
  // baseUrl: 'https://localhost:44320/'
  // baseUrl: 'https://localhost:44318/'
  // baseUrl: 'http://192.168.4.59:90/'
  // baseUrl: 'https://phronesisapi.dilonline.in/'
  // baseUrl: 'http://192.168.0.72:44318/'
  // baseUrl: 'http://192.168.3.8:44318/'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
